import { CornerUpLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import EverestIcon from '../../../assets/Everest-Icon.png';
import LogoIcon from 'icons/src/everest-icon-128x128.svg'
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "ui/components/sidebar";
import {
  DropdownMenu,
  DropdownMenuTrigger,
} from "ui/components/dropdown-menu";


export default function NavHeader() {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-accent text-sidebar-primary-foreground overflow-hidden">
                <img src={LogoIcon} alt="Logo" className="size-full " />
              </div>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-semibold">Everest</span>
                <span className="truncate text-xs">Portfolio</span>
              </div>
            </SidebarMenuButton>
          </DropdownMenuTrigger>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
